import { render, staticRenderFns } from "./ai_governance.vue?vue&type=template&id=60158d3c&scoped=true"
import script from "./ai_governance.vue?vue&type=script&lang=js"
export * from "./ai_governance.vue?vue&type=script&lang=js"
import style0 from "./ai_governance.vue?vue&type=style&index=0&id=60158d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60158d3c",
  null
  
)

export default component.exports